import { FC, useEffect } from 'react';

import Policy from '../../components/Desktop/Policy';

/** End-user license agreement page backed by Termageddon-hosted content. */
const Eula: FC = () => {
  useEffect(() => {
    document.title = 'HomeCook | EULA';
  }, []);

  return (
    <div className="flex h-[900px] flex-col justify-start overflow-y-auto sm:h-screen">
      <p className="text-md mx-auto mt-[90px] font-raleway font-semibold text-primaryDark-200">
        End User License Agreement (EULA)
      </p>
      <div className="mx-auto w-11/12 font-open-sans font-medium">
        <Policy policyKey={process.env.REACT_APP_EULA_KEY} />
      </div>
    </div>
  );
};

export default Eula;
